import React from "react";
import { View } from "react-native";

import EventStats from "./Components/SummaryBar";
import HeroImage from "./Components/HeroImage";

import { type EventOverview } from "@/schemas/events/EventOverview";

type Props = {
  event: EventOverview;
};

function EventHeader({ event }: Props): React.JSX.Element {
  return (
    <View>
      <HeroImage event={event} />
      <EventStats event={event} />
    </View>
  );
}

export default EventHeader;
